/**
 * Whether a venue showcase (`/locale/[slug]`) should be served `noindex`.
 *
 * This file deliberately contains no rule about what makes a showcase empty.
 * That rule has exactly one definition, `RestWorld.Employers.Restaurants.OwnContent`
 * in core-services, and it reaches us already evaluated as `has_own_content` on
 * `GET /employers/restaurants/public/:id`. The sitemap in `Restworld/website`
 * reads the same flag off `GET /employers/restaurants/ids`. The two repositories
 * cannot import from each other, so the backend is the only place both of them
 * see, and a second copy here is what would let the sitemap declare a page that
 * this page tells Google to ignore.
 *
 * All this function does is read a three-state flag correctly, which is the one
 * part that is genuinely ours to get right:
 *
 *   `true`      the showcase has text of its own          -> index
 *   `false`     the showcase has nothing of its own       -> noindex
 *   `undefined` the backend did not answer the question   -> index
 *
 * `undefined` is not hypothetical: the field is additive on an endpoint that
 * answered without it until now, so any response served from a cache filled
 * before the backend release carries no value at all. Folding it in with
 * `false` (which `!hasOwnContent` would do) would `noindex` all 2.984 public
 * showcases in one deploy, and nothing would surface it except the traffic
 * falling weeks later. The unknown case therefore keeps the behaviour we have
 * today, where every showcase is indexed.
 */
export function shouldNoindexVenue(hasOwnContent?: boolean | null): boolean {
  return hasOwnContent === false;
}
